// src/lib/config.ts
export const API_BASE =
  (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/+$/, "") ||
  "https://api.telluswhenwhere.com";
